document.addEventListener("turbolinks:load", function () {
  var pageTop = $('.pagetop')
  // pageTop.smoothScroll()
})
